// WordPress dependencies
// eslint-disable-next-line @wordpress/no-unsafe-wp-apis
import { __experimentalUnitControl as UnitControl, PanelBody, PanelRow, RangeControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

// Internal dependencies
import ProFeatureControl from "../elements/pro-feature-control";
import { getNumberFromString } from "../../utils";
import ColorControl from "../control/color-control";
const coreAssets = window.COCA_BAIS_ASSETS;

export default (props) => {
    const getAttr = (attribute) => {
        const store = props.attributes;
        return !!store[attribute] ? store[attribute] : "";
    };

    const BorderColorField = ColorControl({
        props,
        attribute: "divider_color_normal",
        labelText: __("Default", "wp-before-after-image-slider"),
        resetText: __("Clear", "wp-before-after-image-slider"),
    });

    return (
        <PanelBody
            title={
                <div className="components-panel__body-title__content">
                    <span>{__("Divider", "wp-before-after-image-slider")} </span>
                    {!!props.proFeatureEnabled ? null : (
                        <a
                            href="https://codecanel.com/wp-before-after-image-slider/#product-pricing"
                            target="_blank"
                            style={{ marginTop: "6px" }}
                            title="Buy Pro"
                            onClick={function (e) {
                                e.stopPropagation();
                            }}
                        >
                            <img src={coreAssets.icons.premium} alt="Premium Icon" />
                        </a>
                    )}
                </div>
            }
            initialOpen={false}
            opened={props.attributes.divider_panel_open}
            onToggle={() => props.updateAttributes({ divider_panel_open: !props.attributes.divider_panel_open })}
        >
            <PanelRow>
                <ProFeatureControl {...props} value={"divider_color_normal"}>
                    <div className={"field-control field-inline"}>
                        <span className="field-control__label">{__("Color", "wp-before-after-image-slider")}</span>
                        <div className={"fields-wrapper inline"}>
                            <div className={"field"}>{BorderColorField}</div>
                        </div>
                    </div>
                    <div className={"field-control field-inline"}>
                        <span className="field-control__label">{__("Width", "wp-before-after-image-slider")}</span>
                        <div className={"fields-wrapper inline"}>
                            <div
                                className={"group-field"}
                                style={{ width: "100%", display: "flex", gap: "10px", marginRight: "12px" }}
                            >
                                <UnitControl
                                    className="coca-unit-control"
                                    isPressEnterToChange
                                    onChange={(value) => props.updateAttributes({ divider_width: value })}
                                    value={getAttr("divider_width")}
                                />
                                <RangeControl
                                    onChange={(value) => props.updateAttributes({ divider_width: value })}
                                    max={100}
                                    min={0}
                                    step={1}
                                    allowReset={true}
                                    withInputField={false}
                                    trackColor="#4A25E1"
                                    railColor="#603CFF7A"
                                    value={getNumberFromString(getAttr("divider_width"))}
                                />
                            </div>
                        </div>
                    </div>
                </ProFeatureControl>
            </PanelRow>
        </PanelBody>
    );
};
